import { t } from '@lingui/macro'
import { ProviderCreateDTO } from '@om1/aspen-api/codegen/client/models/ProviderCreateDTO'
import { ProviderDTO } from '@om1/aspen-api/codegen/client/models/ProviderDTO'
import { useProviders } from '@om1/aspen-api/codegen/hooks/useProviders'
import React from 'react'
import { Column, GenericDataPage } from './GenericDataPage'

const providerColumns: Column<ProviderDTO>[] = [
    { key: 'name', type: 'text', editable: true, required: true },
    { key: 'zipCode', type: 'text', editable: true, required: true },
    { key: 'createdByEmail', type: 'email' },
    { key: 'createdDttm', type: 'date' }
]

const ProvidersPage: React.FC = () => {
    return (
        <GenericDataPage<ProviderDTO, 'id', ProviderCreateDTO>
            useData={useProviders}
            useDataArgs={[]}
            columns={providerColumns as Column<ProviderDTO>[]}
            title={t`Providers`}
            detailPageRoute={(id: string) => `/providers/${id}`}
        />
    )
}

export default ProvidersPage
